import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { CardFaceReadiness, CardFaceReadinessAction, CardFaceReadinessStore } from './card-face-readiness-store.types';

const isSameFace = (left: CardFaceReadiness, right: CardFaceReadiness): boolean =>
  left.editorSessionKey === right.editorSessionKey &&
  left.faceId === right.faceId &&
  left.faceNumber === right.faceNumber &&
  left.type === right.type;

export const useCardFaceReadinessStore = create<CardFaceReadinessStore>()(
  devtools(
    (set) => ({
      faceReadiness: [],
      setFaceReadiness: (readiness) =>
        set(
          (state) => {
            const currentFace = state.faceReadiness.find((face) => isSameFace(face, readiness));
            if (
              (currentFace && currentFace.generation > readiness.generation) ||
              (currentFace &&
                currentFace.generation === readiness.generation &&
                currentFace.status === readiness.status)
            ) {
              return state;
            }

            return {
              faceReadiness: currentFace
                ? state.faceReadiness.map((face) => (isSameFace(face, readiness) ? readiness : face))
                : [...state.faceReadiness, readiness],
            };
          },
          false,
          CardFaceReadinessAction.SetFaceReadiness,
        ),
      resetFaceReadiness: () => set({ faceReadiness: [] }, false, CardFaceReadinessAction.ResetFaceReadiness),
    }),
    {
      name: 'CardFaceReadinessStore',
      enabled: process.env.REACT_APP_ZUSTAND_DEVTOOLS === 'true',
      trace: true,
    },
  ),
);
